/**
 * Using layer styles to guarantee that our styles are applied after Mantine's styles.
 *
 * From the Mantine docs:
 * > CSS rules within a layer are grouped together and applied before rules
 * > without a layer. This means that even if you do not have control over
 * > styles import order, you can still override Mantine styles with regular styles.
 * -- https://mantine.dev/styles/mantine-styles/#how-css-layers-work
 */
import '@mantine/core/styles.layer.css';
import '@mantine/dates/styles.layer.css';
import '@mantine/dropzone/styles.layer.css';
import '@mantine/notifications/styles.layer.css';
import '@mantine/spotlight/styles.layer.css';
import 'mantine-composite-filters/styles.css';

import './styles.css';

import './lib/telemetry/sentry';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';

// Catch errors related to deployment of lazily-loaded components.
// (https://github.com/vitejs/vite/issues/11804)
window.addEventListener('vite:preloadError', (event) => {
  console.log(
    `'vite:preloadError' event received, reloading page. Event:`,
    event,
  );
  window.location.reload();
});

const root = createRoot(document.getElementById('root') as any);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
